import { cn } from '@lemonenergy/lemonpie-3'
import type { ComponentProps } from 'react'

export const AuthPage = ({
  className,
  children,
  ...props
}: ComponentProps<'section'>) => (
  <section
    className={cn(
      "bg-expressive-strong bg-[url('/assets/auth-background.svg')] bg-no-repeat bg-center bg-contain",
      'flex flex-col py-0 px-smaller',
      'flex-1 flex-shrink-0 basis-full',
      'box-border',
      'lg:py-0 lg:px-small',
      className,
    )}
    {...props}
  >
    {children}
  </section>
)
